import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { BulkDeleteCollection, GroupResult } from '@thiememeulenhoff/types';
import { ResultEndpointService } from './result.endpoint.service';

@Service()
export class ResultService {
  readonly #http = inject(HttpClient);

  readonly #endpoints = inject(ResultEndpointService);

  fetchGroupResult(
    groupCode: string,
    arrangementCode: string,
    contentIdentifier: string,
    includeTeachers: boolean,
  ) {
    const endpoint = this.#endpoints.groupResult(
      groupCode,
      arrangementCode,
      contentIdentifier,
    );

    const params = { includeTeachers };

    return this.#http.get<GroupResult>(endpoint, { params });
  }

  bulkDeleteGroupResult(groupCode: string, collection: BulkDeleteCollection) {
    const endpoint = this.#endpoints.bulkDeleteGroupResult(groupCode);

    return this.#http.delete(endpoint, {
      body: collection,
    });
  }
}
